export default __webpack_public_path__ + "static/33-100-aa2e6074e81bd0c645706aaa741a2fc0.jpg";